//const imageUrl = "http://192.168.168.57:8080/blogfortis/";

const imageUrl = "https://api.blogfortis.com/";
const getImage = imageUrl+'image/';

const imageService ={
    getImage
};

export default imageService;